// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3VB-s","actionsCol":"EnrolledClinics_actionsCol__1NJzn"};